import React, { useEffect, useState } from 'react';

/**
 * A single round button, bottom-right, that appears once the reader is past
 * the hero and scrolls them back to the top. Hidden from the tab order until
 * it is visible, so it never traps keyboard users on a short page.
 */
const SHOW_AFTER = 640;

const BackToTop: React.FC = () => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setShown(window.scrollY > SHOW_AFTER);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      className={`to-top${shown ? ' to-top--on' : ''}`}
      aria-label="Back to top"
      tabIndex={shown ? 0 : -1}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false">
        <path
          d="M10 16V4M4.5 9.5 10 4l5.5 5.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default React.memo(BackToTop);
